export enum DocumentStatusEnum {
  Draft = 0,
  AuthorisationPending = 1,
  SignaturePending = 2,
  LodgementPending = 3,
  Completed = 4,
}

